import { Component, OnInit, Input, ElementRef, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../shared/providers/loader.service';
import { ValidationService } from '../shared/providers/validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OfferService } from '../shared/providers/offer.service';
import { IOfferDocsOutputModel } from '../shared/models/OfferDetailOutputModel';
import { Subscription } from 'rxjs';
import { AuthService } from '../shared/auth/auth.service';
import { FileUploadService } from '../shared/providers/fileupload.service';
import { DashboardService } from '../shared/providers/dashboard.service';
import { IFileUpload, IPropertyFileUpload } from '../shared/models/fileupload';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@Component({
  selector: 'app-property-offer-document-upload',
  templateUrl: './property-offer-document-upload.component.html',
  styleUrls: ['./property-offer-document-upload.component.css']
})
export class PropertyOfferDocumentUpload implements OnInit {

  LeadOffersDocsList: IOfferDocsOutputModel[];
  docCategories: ILookUp[];
  errorMessage: string;
  documentId: number;
  user: any;
  showRemoveButton: boolean = false;
  errorMessageForDocs: string;
  openUpload: boolean = false;
  selectedFiles: string[] = [];
  selectedFilesForDocs: string[] = [];
  inputFileUpload = {} as IFileUpload;
  clearFiles: number = 0;
  modalRef: BsModalRef;
  modalRefEdit: BsModalRef;
  modalRefFile: BsModalRef;
  @Input() inputOfferGuid: string = "";
  @Input() leadName: string = "";
  @Input() offerPrice: string = "";
  @Input() placedDate: Date;
  @Input() propertyId: number = 0;
  @Input() RefreshTab: string = "";
  @Input() fileTypes: string;
  @Input() BackgroundFileStoring: number = 0;
  @Output() close = new EventEmitter();
  @Output() fileUploaded = new EventEmitter();
  uploadedFiles: IPropertyFileUpload[] = [];
  fileExtensionType = 'document';
  fileUploadType = 'multiple';
  accordianLeadOfferDoclst = [];
  filterOfferList = [];
  fileList = [];
  subscription: Subscription = new Subscription();
  IsFileUploadConfirmed: boolean = false;
  @ViewChild('UploadConfirmation') uploadConfirmation: TemplateRef<any>;
  modalRefuploadConfirmation: BsModalRef;
  constructor(private modalService: BsModalService, private authService: AuthenticationService, private router: Router, private _auth0: AuthService, private offerService: OfferService, private _toastService: ToastService, private http: HttpClient, private Loader: LoaderService, private Toast: ToastService, private _fileUploadService: FileUploadService, public Validation: ValidationService, private _propertyManagementService: PropertyManagementService, private _commonService: CommonService, private _dashboardService: DashboardService) { }
  offerGuid = '';
  ngOnInit() {
    this.offerGuid = this.inputOfferGuid;
    if (this.offerGuid != null) {
      this.bindTable();
      this._propertyManagementService.getFileCategories(6807)
        .subscribe(response => {
          this.docCategories = response.map(o => {
            return { id: o.Id, description: o.Description };
          });
        });
      this.user = this.authService.user;
      if (this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Admin)) {
        this.showRemoveButton = true;
      }
      //this._propertyManagementService.getDocumentCategories().subscribe(response => {
      //    this.docCategories = response.map(o => {
      //        return { id: o.Id, description: o.Description };
      //    });
      //});
    }

    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(f => f.ImageStatus == '' || f.ImageStatus == null && f.sourceUrl == this.router.url && f.RefreshTab == this.RefreshTab);
      if (ongoingList != null && ongoingList.length > 0) {
        localStorage.setItem('currentFileRefreshTab', this.RefreshTab);
      }
      else if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
    }

    this.subscription.add(this._auth0.customObservable.subscribe((res) => {
      if (res.sourceUrl == this.router.url && localStorage.getItem('currentFileRefreshTab') == this.RefreshTab && res.refreshTab == this.RefreshTab) {
        this.bindTable();
      }
    }
    ));
  }
  latestId = 0;
  bindTable() {
    this.offerService.getOfferDocsList(this.offerGuid).subscribe(response => {
      if (response) {
        if (response.length > 0) {
          this.latestId = response[0].LatestId;
        }
        this.LeadOffersDocsList = response;
        this.LeadOffersDocsList.forEach(item => {
          item.Date = this.Validation.convertUTCDateToLocalDate(item.Date);
        });
        this.accordianLeadOfferDoclst = Array.from(new Set(this.LeadOffersDocsList.map((item: any) => item.Category)));
        let i = 0;
        this.filterOfferList = [];
        this.fileList = [];
        this.accordianLeadOfferDoclst.forEach(data => {
          this.filterOfferList.push({
            Category: data,
            Active: 0,
            data: [],
            showChild: false
          });
          this.LeadOffersDocsList.forEach(leadData => {
            if (data == leadData['Category']) {
              this.filterOfferList[i].data.push({
                Category: leadData['Category'],
                DocumentId: leadData['DocumentId'],
                Date: leadData['Date'],
                FileName: leadData['FileName'],
                LatestId: leadData['LatestId'],
                Path: leadData['Path'],
                UploadedBy: leadData['UploadedBy']
              });
              this.fileList.push({
                Category: leadData['Category'],
                DocumentId: leadData['DocumentId'],
                Date: leadData['Date'],
                FileName: leadData['FileName'],
                LatestId: leadData['LatestId'],
                Path: leadData['Path'],
                UploadedBy: leadData['UploadedBy'],
                CategoryId: leadData['CategoryId']
              })
            }
          });
          i = i + 1;
        });
      }
    });
  }

  filesCollection = [];
  categoryList = [];

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      var ext = item["name"].toUpperCase().split('.').pop() || item["name"];
      if (item["type"] === 'application/pdf') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/vnd.ms-excel' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'application/msword' ||
        item["type"] === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if (item["type"] === 'text/plain') {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else if ((item["type"] === 'image/x-dwg') || (ext === "DWG")) {
        const fileObj =
        {
          name: item["name"],
          category: 0,
          file: item
        }
        this.filesCollection.push(fileObj);
      }
      else {
        this._toastService.addToast({
          title: 'Error Extension',
          msg: `Please upload .pdf/.xlsx/.xls/.docx/.doc/.txt/.dwg files`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });
  }
  removeImage(fileIndex: number, event: any) {
    if (fileIndex > -1) {
      //this.selectedFiles.splice(fileIndex, 1);
      this.filesCollection.splice(fileIndex, 1);
    }
  }
  onFilesClear() {
    this.clearFiles++;
    this.selectedFiles = [];
    this.filesCollection = [];
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  documentPreview: BsModalRef;
  docPreview: any;

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  categoryId: number;
  UpdateDocCategory() {
    this._dashboardService.saveBOEPropertyDocumentCategory(this.editFileId, this.categoryId, true, this.user.Id).subscribe(res => {
      this.modalRefEdit.hide();
      this.bindTable();
      this._toastService.addToast({ title: 'Success', msg: 'Document category updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    })
  }

  openModal(template: TemplateRef<any>, classes: any, documentId: number, i: any) {

    this.modalRef = this.modalService.show(template, { class: classes });
    this.documentId = documentId;
  }
  onRemoveDocument() {
    this._propertyManagementService.deleteDocument(this.documentId, this.user.Id).subscribe(response => {
      this.bindTable();
      if (response.toString() === 'true') {
        this._toastService.addToast({
          title: 'Success',
          msg: 'Document deleted!',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });



      } else {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Image could not be deleted',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    });

  }

  uploadFiles() {
    this.Loader.display(true);
    let valid = true;
    for (let i = 0; i < this.filesCollection.length; i++) {
      if (parseInt(this.filesCollection[i]["category"]) === 0) {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Please Select Catogory", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.Loader.display(false);
        valid = false;
        break;
      }
    }
    if (valid) {
      let uploadCount = 1;
      this.filesCollection.forEach(item => {
        let fileToUpload = [];
        fileToUpload.push(item["file"]);
        this.uploadedFiles.push({
          id: 0,
          objectId: this.latestId,
          type: 'Documents',
          documentName: item["name"],
          fileCategoryId: item["category"],
          objectTypeId: 303,
          FileContent: null,
          isDefault: false,
          ImageGuid: this.newGuid(),
          PropertyGuid: '',
          ImageStatus: '',
          OfferGuid: this.inputOfferGuid,
          fileToUpload: fileToUpload,
          sourceUrl: this.router.url,
          RefreshTab: this.RefreshTab
        });
        this.inputFileUpload.documentName = item["name"];
      });
      this.clearFiles++;
      if (this.uploadedFiles != null) {
        this.onFilesClear();
        this.Loader.display(false);
        this.imageupload();
      /*  this.onClose();*/
        this.Toast.addToast({ title: '', msg: "File uploads are in progress, please don't reload or close the website until complete.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
      }
    }
  }
  openAccordian(index) {
    if (index.Active == 1) {
      index.Active = 0;
    }
    else {
      index.Active = 1;
    }
  }

  editFileId: number;

  openEditModal(template: TemplateRef<any>, classes: any, id: number, category: number) {
    this.categoryId = category;
    this.editFileId = id;
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  imageupload() {
    localStorage.setItem('currentFileRefreshTab', this.RefreshTab);
    this._auth0.FileUpload(this.uploadedFiles);
    this.uploadedFiles = [];
  }
  toggle_child(data) {
    this.filterOfferList.map(item => {
      if (data === item) {
        item.showChild = !item.showChild;
      }
      else {
        item.showChild = false;
      }
    })
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  onClose() {
    this.close.emit();
  }
}
